
import { FileText } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CompetitionSection = () => {
  const { t } = useTranslation('individuals');

  const features = [
    {
      icon: <FileText className="w-6 h-6 text-brand-orange" />,
      title: t('competition.features.raep.title'),
      description: t('competition.features.raep.description')
    },
    {
      icon: <FileText className="w-6 h-6 text-brand-orange" />,
      title: t('competition.features.report.title'),
      description: t('competition.features.report.description')
    },
    {
      icon: <FileText className="w-6 h-6 text-brand-orange" />,
      title: t('competition.features.interview.title'),
      description: t('competition.features.interview.description')
    },
    {
      icon: <FileText className="w-6 h-6 text-brand-orange" />,
      title: t('competition.features.mobility.title'),
      description: t('competition.features.mobility.description')
    }
  ];

  return (
    <section className="py-24 bg-card">
      <div className="container-custom">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl sm:text-5xl font-bold text-center bg-clip-text text-transparent bg-gradient-to-r from-brand-blue to-brand-orange mb-6">
              {t('competition.title')}
            </h2>
            <p className="text-xl text-brand-orange mb-12">
              {t('competition.subtitle')}
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-8">
            {features.map((feature, index) => (
              <div 
                key={index} 
                className="group bg-background rounded-xl p-8 hover:shadow-xl transition-all duration-300 border border-border hover:-translate-y-1"
              >
                <div className="flex items-center justify-center mb-6">
                  <div className="p-3 bg-brand-orange/10 dark:bg-brand-orange/5 rounded-xl group-hover:scale-110 transition-transform">
                    {feature.icon}
                  </div>
                </div>
                <h3 className="text-xl font-medium text-brand-blue dark:text-brand-orange mb-4 text-center group-hover:text-[#8B5CF6] transition-colors">
                  {feature.title}
                </h3>
                <p className="text-muted-foreground text-center leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>

          <div className="text-center mt-16">
            <p className="text-xl text-muted-foreground mb-8">
              {t('competition.conclusion')}
            </p>
            <a
              href="/search"
              className="inline-flex items-center px-8 py-4 rounded-lg bg-gradient-to-r from-brand-blue to-brand-orange text-white hover:opacity-90 transition-all duration-300 shadow-lg hover:shadow-xl text-lg"
            >
              {t('competition.cta')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompetitionSection;
